import React from "react";

interface ISpanTextProps {
  children: React.ReactNode;
}

export const SpanText = ({ children }: ISpanTextProps) => {
  return <span>{children}</span>;
};
